import {
	getCategories,
	getDesignGetProducts,
	getProducts,
	getFrontCategories,
	getDesignGetCategories,
	getDesignProducts,
	getproductsDetail,
	getCategoryProduct,
} from '../../api/all.js'
let apiConfig = [{
		wmDetail: {
			requestData: {
				async mounteds(that, type, params, to) {
					console.log('wmDetailparams', params)
					console.log('wmDetailparamsto', to)
					if (to.params.id && type != 'design') {
						let dataDetail = await getproductsDetail({
							product_id: to.params.id
						})
						params.data.data.dataDetail = dataDetail
						console.log('wmDetailparams', params)
						
					}
				}
			}
		},
	},
	{
		wmNav: {
			requestData: {
				async mounteds(that, type, params) {
					console.log('wmNav params', params)
					if (params.list) {
						let menu = params.list['menu']
						params.data.data.list = menu
					}
				}
			}
		},
	},

	{
		wmFooter: {
			requestData: {
				async mounteds(that, type, params) {
					console.log('wmFooter params', params)
					if (params.list) {
						let footer = params.list['footer']
						params.data.data.footerData = footer
					}
				}
			}
		},
	},

	{
		wmGoodsList: {
			requestData: {
				async mounteds(that, type, params) {
					if (type == 'build') {
						console.log('wmGoodsListwmGoodsList', params)
						
						if (params.data.layoutConfig.type == 'tab') {
							if(params.item.applyType == that.equipment || params.item.applyType == 'all'){
								if (params.data.data.classfiy.length > 0) {
									
									(async () => {
										const data = await getCategoryProduct({
											id: params.data.data.classfiy[0].classfiyId,
											num: params.data.data.classfiy[0].num
										})
										// params.data.data.classfiy[0].data = data.data.data
										that.$set(params.data.data.classfiy[0],'data',data.data.data)
									})();
								}
							}
						} else {
							
							if(params.item.applyType == that.equipment  || params.item.applyType == 'all'){
								for (const item of params.data.data.classfiy) {
									// 立即执行异步函数，不阻塞循环
									(async () => {
										const data = await getCategoryProduct({
											id: item.classfiyId,
											num: item.num
										})
										that.$set(item,'data',data.data.data)
										// item.data = data.data.data
										console.log('item.data拉拉',item.data)
									})();
								}
							}
							

							// if(params.item.applyType == that.equipment){
							// 	params.data.data.classfiy.forEach(async item => {
							// 		const data = await getCategoryProduct({
							// 			id: item.classfiyId,
							// 			num: item.num
							// 		})
							// 		item.data = data.data.data
							// 		console.log('itemrequestData',item)
							// 	})
							// }

							// for (let i = 0; i < params.data.data.classfiy.length; i++) {
							// 	const data = await getCategoryProduct({
							// 		id: params.data.data.classfiy[i].classfiyId,
							// 		num: params.data.data.classfiy[i].num
							// 	})
							// 	params.data.data.classfiy[i].data = data.data.data
							// }
						}
					}
				}
			}
		},
	},

	{
		wmGoods: {
			requestData: {
				async mounteds(that, type, params) {
					// params.classfiy = params.data.classfiy
					console.log('type', type)
					params.classfiy = params.data.data.classfiy
					let wsid = that.$cookies.get("wsid")
					// 请求商品
					let selectListData;
					console.log('mounteds params', params)
					let classfiyIds = []
					params.classfiy.forEach(classItem => {
						classfiyIds.push(classItem.id)
					})
					if (type != 'build') {
						// let categories = await getDesignGetCategories({
						// 	wsid,
						// 	ids: classfiyIds
						// })
						// console.log('categories', categories)
						// let classfiyList = categories.data.data

						// for (let i = 0; i < params.classfiy.length; i++) {
						// 	let item = params.classfiy[i]
						// 	let selectListIds = item.selectListIds
						// 	// console.log('selectListIds', item)
						// 	// classfiyList.forEach(classfiyItem => {
						// 	// 	if (item.id == classfiyItem.id) {
						// 	// 		item.description = classfiyItem.description
						// 	// 	}
						// 	// })
						// 	let products = await getDesignProducts({
						// 		wsid,
						// 		id: item.id,
						// 	})
						// 	// let selectListData = await getDesignGetProducts({
						// 	// 	wsid,
						// 	// 	ids: selectListIds
						// 	// })
						// 	// console.log('item', item)
						// 	// console.log('selectListData', selectListData)
						// 	// item.selectList = selectListData.data.data
						// 	// item.selectList  = goodsList
						// 	item.products = products.data.data
						// }


						// params.classfiy.forEach(async item=>{

						// })
					} else {
						// let categories = await getFrontCategories({
						// 	wsid,
						// 	ids: classfiyIds
						// })
						// console.log('categories', categories)
						// let classfiyList = categories.data.data

						for (let i = 0; i < params.classfiy.length; i++) {
							let item = params.classfiy[i]
							let selectListIds = item.selectListIds
							// classfiyList.forEach(classfiyItem => {
							// 	if (item.id == classfiyItem.id) {
							// 		item.description = classfiyItem.description
							// 	}
							// })

							let selectListData = await getProducts({
								wsid,
								ids: selectListIds
							})
							item.selectList = selectListData.data.data
						}


						// params.classfiy.forEach(async item=>{

						// 	let selectListIds = item.selectListIds
						// 	classfiyList.forEach(classfiyItem=>{
						// 		if(item.id == classfiyItem.id) {
						// 			item.description = classfiyItem.description
						// 		}
						// 	})

						// 	let selectListData = await getProducts({
						// 		wsid,
						// 		ids:selectListIds
						// 	})
						// 	item.selectList = selectListData.data.data
						// })
					}
				}
			}
		}
	}
]
export default apiConfig